module.exports = __webpack_public_path__ + "img/alert-no-set.1deb062c.svg";